/** Persist list query so info "List" returns with filters. */
export const PRODUCTION_LIST_SEARCH_KEY = "production-list-search";

export const getProductionListPath = () => {
  const q = sessionStorage.getItem(PRODUCTION_LIST_SEARCH_KEY) || "";
  return `/production${q}`;
};

export const getProductionRowId = (record) =>
  record?.ProductionNo ?? record?.production_no ?? record?.id;
